import React from 'react';

const FranchiseFees = ({toSection,section}) => {

  const facts = [
    {
      title: "STEM Education Market Growth",
      content: "The global STEM education market is projected to grow at a compound annual growth rate (CAGR) of 14.4% from 2022 to 2028, driven by the rising demand for technology-based learning and the increasing focus on digital skills across educational institutions worldwide.",
      source: "Source: \"STEM Education Market - Global Industry Analysis,\" 2023",
      bgColor: "bg-[#0088CE]"
    },
    {
      title: "Digital Education Expansion",
      content: "The value of the global digital education market, which includes STEM-related programs, is anticipated to reach $77.23 billion by 2023, as STEM continues to be prioritized for its role in the evolving tech-driven job market.",
      source: "Source: \"Global STEM Education Market Report,\" Grand View Research, 2022",
      bgColor: "bg-[#F18917]"
    },
    
  ];
  return (
    <div style={{marginTop: '-40px'}} id={section} className="relative">
      {/* Top wave */}
      <div style={{zIndex: 1}} className="absolute top-0 left-0 right-0">
        <svg 
          viewBox="0 0 1440 200" 
          className="w-full"
          preserveAspectRatio="none"
          style={{ height: '120px', transform: 'rotate(180deg)' }}
        >
          <path 
            fill="#002147"
            fillOpacity="1" 
            d="M0,160L48,144C96,128,192,96,288,80C384,64,480,64,576,80C672,96,768,128,864,128C960,128,1056,96,1152,80C1248,64,1344,64,1392,64L1440,64L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
          />
        </svg>
      </div>

      <div className="bg-white relative py-20">
        <div className="container mx-auto px-4">
          {/* Main Info Banner */}
          <div className=" mx-auto mb-16 text-center">
            <div className="bg-white text-white rounded-xl p-8 mb-12">
              <h2 className="font-['Grandstander'] text-3xl text-[#002147] font-bold mb-4">
              Supplemental Education Programs are a <span className='text-[#FF1278]'>$77</span> Billion Industry Worldwide

              </h2>
              <p className="text-[#002147] text-lg mb-16 font-['Lexend']">
              The markets for birthday parties and summer camps are <span className='text-[#FF1278]'>$25</span> billion and <span className='text-[#FF1278]'>$3</span> billion, respectively. Tinker Labs offers a unique opportunity to capitalize on three profitable markets for one competitively priced investment.
            </p>
            <div className="grid md:grid-cols-2 gap-6 mb-16">
              {facts.map((fact, index) => (
                <div 
                  key={index} 
                  className={`${fact.bgColor} rounded-xl p-6 text-white`}
                >
                  <h3 className="font-['Lexend'] text-lg font-semibold mb-4">
                    {fact.title}
                  </h3>
                  <p className="text-sm mb-4 font-['Lexend']">
                    {fact.content}
                  </p>
                  <p className="text-xs italic font-['Lexend']">
                    {fact.source}
                  </p>
                </div>
              ))}
            </div>
            <div style={{zIndex:10000}} className="text-center">
              <button onClick={()=>toSection('contact-form')} className="bg-[#FF1278] text-white px-8 py-3 rounded-full font-['Lexend'] font-semibold hover:bg-[#FF5A1F] transition-all">
                Request a Franchise Informational Brochure
              </button>
            </div>
            </div>

          
          </div>
        </div>
      </div>

      {/* Bottom wave */}
      <div className="absolute bottom-0 left-0 right-0">
        <svg 
          viewBox="0 0 1440 200" 
          className="w-full"
          preserveAspectRatio="none"
          style={{ height: '120px' }}
        >
          <path 
            fill="#B8E1FF"
            d="M0,64L48,80C96,96,192,128,288,128C384,128,480,96,576,85.3C672,75,768,85,864,96C960,107,1056,117,1152,112C1248,107,1344,85,1392,74.7L1440,64L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
          />
        </svg>
      </div>
    </div>
  );
};

export default FranchiseFees;